import React from "react";
import "./style.scss";

const Fieldset: React.FC = ({ children }) => {
  return <section className="fieldset">{children}</section>;
};

export default Fieldset;
